import { Component, OnInit } from '@angular/core';
import { Shared } from '../shared.service';

@Component({
  selector: 'app-account',
  templateUrl: './account.component.html',
  styleUrls: ['./account.component.scss']
})
export class AccountComponent implements OnInit {

  brewType;

  constructor(public shared: Shared) {
  }

  ngOnInit() {
  }

  canView(roles){
      let arr = roles.split(',');
      if(arr.includes(this.shared.firebase_user.role)){
          return true;
      }
      return false;
  }

  save(){
    delete this.shared.settings.$key;
      this.shared.settingsRef.update(this.shared.settings);
  }

}



// WEBPACK FOOTER //
// ./src/app/account/account.component.ts